import { AppRoute } from '@agentselly/immodossier-shared';
import { WrapperWidget } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { Button } from '~/components/ui/Button';
import { useTranslate } from '@tolgee/react';

export function BadRequestWidget() {
  const { t } = useTranslate();

  return (
    <WrapperWidget>
      <EmptyState
        title={t('error_badrequest_title')}
        description={t('error_badrequest')}
        actions={
          <a href={AppRoute.ROOT}>
            <Button showArrow>{t('error_badrequest_link')}</Button>
          </a>
        }
      />
    </WrapperWidget>
  );
}
